import { requestMsLog as request  } from '../request';
export const xhrHeartBeat = (data) => {
  return request({
    url: '/v1/pro/session',
    method: 'post',
    data,
  });
};

export const logReport = (data) => {
  return request({
    url: '/v1/pro/report',
    method: 'post',
    data,
  });
};
